var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTrx = function SvgTrx(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FF0013",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.663 9.77c-.738-.65-1.763-1.642-2.593-2.344l-.052-.03a1.078 1.078 0 0 0-.271-.148c-2.01-.355-11.36-2.018-11.54-1.998a.346.346 0 0 0-.144.051l-.046.036a.511.511 0 0 0-.128.198l-.01.03v.194c1.05 2.786 5.208 11.908 6.029 14.054.05.147.143.422.317.437h.041c.093 0 .492-.503.492-.503s7.142-8.227 7.864-9.102c.093-.107.175-.224.247-.346a.492.492 0 0 0-.026-.284.645.645 0 0 0-.18-.245Zm-6.08.962 3.046-2.4 1.789 1.566-4.834.834Zm-1.184-.158L7.155 6.486l8.49 1.49-3.246 2.598Zm.472 1.068 5.367-.824-6.136 7.032.769-6.208ZM6.442 6.898l5.522 4.449-.8 6.508L6.442 6.898Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTrx);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "trx.2f355747af692411776a0b0549de8fc9.svg";